import { LoadInvoices } from './invoices.actions';

export const InvoicesLoadingActions = [LoadInvoices];
